// src/pages/MentionsLegales.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';

function MentionsLegales() {
  const { t } = useTranslation();

  return (
    <main className="legal-page">
      <header className="page-hero">
        <div className="page-hero__inner">
          <span className="page-hero__label">{t('legal.heroLabel')}</span>
          <h1 className="page-hero__title">{t('legal.heroTitle')}</h1>
        </div>
      </header>
      <section className="legal-content">
        <h2>{t('legal.editorTitle')}</h2>
        <p>
          {t('legal.editorText1')}<br />
          {t('legal.editorText2')}<br />
          {t('legal.editorEmail')} : madadline@gmail.com<br />
          {t('legal.editorPhone')} : +212669428878
        </p>

        <h2>{t('legal.hostTitle')}</h2>
        <p>
          {t('legal.hostText1')}<br />
          {t('legal.hostText2')}
        </p>

        <h2>{t('legal.ipTitle')}</h2>
        <p>{t('legal.ipText')}</p>

        <h2>{t('legal.respTitle')}</h2>
        <p>{t('legal.respText')}</p>
      </section>
    </main>
  );
}

export default MentionsLegales;